import React, { FC } from "react";

import { SanitizeHtml } from "@keepeek/refront-components";

import { parseOptionsInternalUrl } from "../../utils/parseInternalUrl";

type KNewsWidgetContentProps = {
  content?: string;
};

const KNewsWidgetContent: FC<React.PropsWithChildren<KNewsWidgetContentProps>> = function ({
  content,
}) {
  if (content) {
    return (
      <SanitizeHtml
        sanitizeOptions={{ allowedAttributes: false, allowedTags: false }}
        parseOptions={parseOptionsInternalUrl}
        html={content}
      />
    );
  }

  return null;
};

export default KNewsWidgetContent;
